<script lang="ts">
	import PricingCurrencySelect from '../pricing/PricingCurrencySelect.svelte'
	import PricingPackageBillingCycleSwitch from '../pricing/PricingPackageBillingCycleSwitch.svelte'
	import PricingSlider from '../pricing/PricingSlider.svelte'
	import { defaultMonthlyRevenue } from '../pricing/defaultMonthlyRevenue'
	import { MembershipPlanId } from '../pricing/membershipPlanId'
	import EstimatePriceTable from './EstimatePriceTable.svelte'
	import { plans } from './plans'
	import { MembershipsV1BillingCycle } from '@sdk/Api'
	import { type PricingPlanRecord } from 'datocms/models'

	interface Props {
		pricingPackages: PricingPlanRecord[]
		membershipPlanId: MembershipPlanId
	}

	let { pricingPackages, membershipPlanId = $bindable() }: Props = $props()

	let billingCycle = $state(MembershipsV1BillingCycle.BILLING_CYCLE_ANNUAL)

	function handleSetPlan(planId: MembershipPlanId) {
		membershipPlanId = planId
	}

	let monthlyRevenue = $state(defaultMonthlyRevenue)
</script>

<div class="font-display max-w-form-wide m-auto text-center md:text-2xl md:leading-7">
	<h1 class="text-green-trackdesk-light font-bold max-md:px-8">
		Pricing depends on the revenue generated by affiliates.
	</h1>

	<p class="text-muted">
		The table below outlines monthly prices by revenue tier. Go for an annual payment to get 2
		months absolutely FREE.
	</p>
</div>

<div class="mt-7"></div>

<PricingSlider bind:monthlyRevenue {pricingPackages} />

<div class="mt-7"></div>

<div class="overflow-hidden">
	<div class="flex flex-wrap-reverse justify-between gap-6">
		<div class="flex flex-1 gap-2">
			{#each plans as plan}
				<button
					onclick={() => handleSetPlan(plan.id)}
					class="
					font-display group relative flex-1 rounded-xl px-3 py-3 max-md:text-sm md:w-[130px] md:px-6 md:py-2
					{membershipPlanId === plan.id
						? `rounded-b-none ${plan.activeStyles}`
						: `z-10 ${plan.inactiveStyles}`}
				"
				>
					{plan.label}
					{#if membershipPlanId === plan.id}
						<div class={`${plan.highlightColor} absolute inset-x-0 top-full h-5`}></div>
						<div
							class="absolute bottom-0 -mb-2 h-4 w-4 {plan.highlightColor} right-full group-first:hidden"
						>
							<div class="h-full w-full rounded-br-xl bg-white dark:bg-gray-800"></div>
						</div>
						<div class="absolute bottom-0 -mb-2 h-4 w-4 {plan.highlightColor} left-full">
							<div class="h-full w-full rounded-bl-xl bg-white dark:bg-gray-800"></div>
						</div>
					{/if}
				</button>
			{/each}
		</div>
		<div class="flex grow items-center justify-end gap-2">
			<PricingCurrencySelect />

			<PricingPackageBillingCycleSwitch variant="green" bind:billingCycle />
		</div>
	</div>

	<div
		class="
		mt-2 rounded-xl p-2
		{plans.find((plan) => plan.id === membershipPlanId)?.highlightColor || ''}
		{membershipPlanId === 'PLAN_ID_STARTER' ? 'rounded-tl-none' : ''}
	"
	>
		<div class="border-line text-dark relative rounded-xl border-2 bg-white py-2 md:py-4">
			<div class="-mx-0.5">
				<EstimatePriceTable {monthlyRevenue} {membershipPlanId} {billingCycle} />
			</div>
		</div>
	</div>
</div>
